// frontend/src/navigation/paletteEntries.jsx
import {
  Package, Sparkles, RefreshCw, Eye, Mail, ShieldOff, BellRing, Wrench,
  Plug, Briefcase, ScrollText, KeyRound, Bell, TriangleAlert, BookOpen, Settings,
} from 'lucide-react'
import { NAV_ITEMS } from './navItems'
import { FS } from '../theme/tokens'

/**
 * paletteEntries — was die Befehlspalette anbietet (W-20).
 *
 * @description
 *   Von 73 Routen haben 49 keinen Sidebar-Eintrag. Die Antwort darauf ist
 *   nicht, mehr in die Leiste zu haengen — die Leiste ist eine kuratierte
 *   Auswahl und bleibt es. Die Antwort ist ERREICHBARKEIT: Atlassian loest
 *   dasselbe Problem mit einer kuratierten Leiste plus einer Palette, die die
 *   Leiste nicht vollstaendig sein laesst.
 *
 *   Quelle 1 ist der Katalog aus W-17 — dieselben Eintraege wie die Sidebar,
 *   also koennen die zwei nicht auseinanderlaufen.
 *   Quelle 2 sind die Flaechen, die es gibt und die niemand in eine Leiste
 *   haengen wuerde: Admin-Unterseiten, Werkzeugseiten, Sonderansichten.
 *
 * 🔴 WAS HIER NICHT STEHEN DARF — und warum das die halbe Arbeit ist:
 *   - **Parametrisierte Routen** (`/products/:sku`, `/vendors/:id`): ohne
 *     Parameter nicht anwaehlbar. Ein Paletteneintrag, der auf 404 zeigt, ist
 *     schlimmer als kein Eintrag — er sieht aus wie ein Weg und ist keiner.
 *   - **Weiterleitungen** (`/pricing`, `/market`, `/purchase-orders`): sie
 *     landen woanders. Wer sie anwaehlt, steht auf einer Seite, deren Namen er
 *     nicht gewaehlt hat.
 *   - **Eingang** (`/login`): keine Handlung, die man sucht.
 */

/** Lucide traegt Groesse und Strichstaerke als Props. */
const L = (C) => <C size={18} strokeWidth={1.75} />

/**
 * Flaechen ohne Sidebar-Eintrag. Alle Pfade sind gegen `App.js` geprueft —
 * die Admin-Kinder sind VERSCHACHTELT und heissen wirklich `/admin/...`.
 */
export const EXTRA_ENTRIES = [
  { path: '/products/attributes',        label: 'Product Attributes',      icon: L(Package) },
  { path: '/recommendations',            label: 'Recommendations',         icon: L(Sparkles) },
  { path: '/scrapers/watch-findings',    label: 'Watch Findings',          icon: L(Eye) },
  { path: '/scrapers/redirect-reviews',  label: 'Redirect Review Queue',   icon: L(RefreshCw) },
  { path: '/admin',                      label: 'Admin Overview',          icon: L(Settings) },
  { path: '/admin/integrations',         label: 'Admin · Integrations',    icon: L(Plug) },
  { path: '/admin/jobs',                 label: 'Admin · Jobs',            icon: L(Briefcase) },
  { path: '/admin/audit',                label: 'Admin · Audit Feed',      icon: L(ScrollText) },
  { path: '/admin/secrets',              label: 'Admin · Secrets',         icon: L(KeyRound) },
  { path: '/admin/notifications',        label: 'Admin · Notifications',   icon: L(Bell) },
  { path: '/admin/cron-failures',        label: 'Admin · Cron Failures',   icon: L(TriangleAlert) },
  { path: '/admin/docs',                 label: 'Admin · Docs',            icon: L(BookOpen) },
  { path: '/admin/settings',             label: 'Admin · Settings',        icon: L(Settings) },
  { path: '/admin/email-log',            label: 'Email Log',               icon: L(Mail) },
  { path: '/admin/gdpr-wipe',            label: 'GDPR Wipe',               icon: L(ShieldOff) },
  { path: '/admin/notification-tester',  label: 'Test notifications',      icon: L(BellRing) },
  { path: '/admin/spare-parts-review',   label: 'Spare Parts Review',      icon: L(Wrench) },
]

/** Katalog und Zusatz zusammen, ohne Doppelte. Der Katalog gewinnt. */
export function alleEintraege() {
  const gesehen = new Set()
  const out = []
  for (const [path, e] of Object.entries(NAV_ITEMS)) {
    gesehen.add(path); out.push({ ...e, path })
  }
  for (const e of EXTRA_ENTRIES) {
    if (!gesehen.has(e.path)) { gesehen.add(e.path); out.push(e) }
  }
  return out
}

/**
 * Treffer fuer eine Eingabe.
 *
 * 🔴 Praefix vor Teilstring, und der Pfad zaehlt mit. Wer „ref" tippt, meint
 * „Refunds" (Praefix) und nicht „Redirect Review Queue" — beides waere ein
 * Teilstringtreffer, aber nur einer ist gemeint. Und wer den Pfad kennt
 * (`/rma/sla`), soll ihn tippen koennen, statt das Label raten zu muessen.
 */
export function suche(eintraege, q) {
  const s = q.trim().toLowerCase()
  if (!s) return eintraege
  const bewertet = []
  for (const e of eintraege) {
    const label = e.label.toLowerCase(), pfad = e.path.toLowerCase()
    let rang = -1
    if (label.startsWith(s)) rang = 0
    else if (pfad.startsWith(s) || pfad.startsWith('/' + s)) rang = 1
    else if (label.includes(s)) rang = 2
    else if (pfad.includes(s)) rang = 3
    if (rang >= 0) bewertet.push([rang, e])
  }
  return bewertet.sort((a, b) => a[0] - b[0] || a[1].label.localeCompare(b[1].label)).map(([, e]) => e)
}

/** Schriftgroesse fuer die Palette — aus dem Token, nicht als Literal (Regel 22). */
export const PALETTE_FS = { label: FS.base, pfad: FS.sm }
